import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class HacizVarakasiListeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "HacizVarakasiListe";
        super(baseUrl);
    }


    geHacizVarakasiListeListe(sicilKodu:number, durum: number, ) {
        var request = new HacizVarakasiListeRequest(sicilKodu, durum);
        return this.post("", request, false);
    }

}
export default new HacizVarakasiListeAPI();
class HacizVarakasiListeRequest {
    public sicilKodu: number;
    public Durum: number;
    constructor(sicilKodu:number, durum: number) {
        this.sicilKodu = sicilKodu;
        this.Durum = durum;
    }
}
export { HacizVarakasiListeRequest };